import { render, staticRenderFns } from "./DriverMaster.vue?vue&type=template&id=1b5c3ede&scoped=true"
import script from "./DriverMaster.vue?vue&type=script&lang=js"
export * from "./DriverMaster.vue?vue&type=script&lang=js"
import style0 from "./DriverMaster.vue?vue&type=style&index=0&id=1b5c3ede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5c3ede",
  null
  
)

export default component.exports